<i [pTooltip]="tooltip()" [class]="itemClass()"
    [routerLink]="routerLink()" [routerLinkActive]="routerLinkActiveClass()" (click)="onClick()">
</i>
